import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

/**
 * Servicio de storage
 */
import { StorageService } from "../services/storage.service";

/**
 * Servicio genérico se configuración de la aplicación
 */
import { AppGpSettings } from "../services/settings.service";

/**
 * Clase principal para lanzar el Spinner
 */
import { SpinnerAlertService } from "./spinner-alert.service";

/**
 * - Clase principal de usos generales
 * - Esta clase es utilizada por la mayoria de la clases para acciones generales
 * --- Alertas
 * --- Avisos de proceso
 * --- Manejo de errores
 * --- Limpiar llaves de sesión
 * --- Llevar hacia una ruta principal
 *
 * @author: Isaac Salgado @iiSalgado
 * @author: Jesús Galvan
 * @version: 11/09/2018
 */
@Injectable()
export class MainService {
  /**
   * Referencias hacia servicios
   *
   * @param router Router
   * @param storageService StorageService
   * @param spinnerAlertService SpinnerAlertService
   * @param messageService MessageService
   */
  constructor(
    private router: Router,
    private storageService: StorageService,
    private spinnerAlertService: SpinnerAlertService
  ) {}

  /**
   * - Se lee el buc se del storage
   * - Se complementa el buc con 7 ceros a la izquierda para poder
   * leer los 8 dígitos que requieren los servicios
   */
  getBuc(): string {
    return this.storageService.get("data-sso-validate")
      ? `0000000${this.storageService.get("data-sso-validate")["buc"]}`.substr(
          -8
        )
      : "";
  }

  /**
   * - Limpia llaves que se encuentran en el storage
   * - Cada llave viene separada por comas
   * ejemplo: "key1,key2,key3,key4"
   * - Mueve hacia la ruta principal, el valor se obtiene desde
   * la clase principal de configuración
   * @param keys string
   */
  clearKeysNavigateRoot(keys?: string): void {
    this._clearKeys(keys);
    this.router.navigate([AppGpSettings.URL_ROOT]);
  }

  /**
   * - Limpia llaves que se encuentran en el storage
   * - Cada llave viene separada por comas
   * ejemplo: "key1,key2,key3,key4"
   * @param keys string
   */
  clearKeys(keys?: string): void {
    this._clearKeys(keys);
  }

  /**
   * - Ir a la ruta principal
   * - Se optine la ruta desde la clase principal
   * de configuración
   */
  goToRoot(): void {
    this.router.navigate([AppGpSettings.URL_ROOT]);
  }

  /**
   * Muestra / Oculpa Spinner mientras un proceso
   * está ocurriendo
   * @param show boolean
   */
  showSpinner(show: boolean): void {
    if (show) {
      this.spinnerAlertService.show();
    } else {
      this.spinnerAlertService.hide();
    }
  }

  /**
   * Elimina llaves del storage
   * Ejemplo "key1,key2,key3"
   * @param keys string
   */
  private _clearKeys(keys?: string): void {
    keys = keys.trim() || "";
    keys.split(",").forEach((key) => {
      this.storageService.clearKey(key.trim());
    });
  }

  /**
   * Recupera el token sso de la app nativa
   * @param tokenSSO
   */
  /*getToken(tokenSSO: any): Observable<any>  {
      let tmpTokenSSO = "";
      if(this.storageService.get("ENV") === "dev"){
        tmpTokenSSO = "12345678";
      } else {
        tmpTokenSSO = tokenSSO;
      }
      const urlToken = AppGpSettings.URL_TOKEN.replace("{{ENV}}", this.storageService.get("ENV")).replace("{{DOM}}", this.storageService.get("DOM"));
      return this.httpClient.post(urlToken, { "tokenSSO": tmpTokenSSO });//.toPromise().then(response => {
        // this.storageService.set('data-sso-validate', response['data']);
      //});
  }*/

  /**
   * Obtiene la hora actual
   * - Si se omite [t] se comprueba del storage que exista la hora que proporciona el server
   * - Si se omite [t] y si no existe hora del server en el storage se lee la hora local
   * - Se se proporciona [t] se compruba el formato de fecha para obtener la hora,
   * en caso de no existir se lee local
   * @param t string
   */
  getHora(t?: string): string {
    const today = new Date();
    const timeHm = `${today.toTimeString().substr(0, 5)}.`;
    let time = timeHm;
    if (t) {
      time = t.split(" ").length > 1 ? t.split(" ")[1].substr(0, 5) : timeHm;
    } else {
      if (this.storageService.get("msgRsHdr-serverDt")) {
        time =
          this.storageService.get("msgRsHdr-serverDt").split(" ").length > 1
            ? this.storageService
                .get("msgRsHdr-serverDt")
                .split(" ")[1]
                .substr(0, 5)
            : timeHm;
      }
    }
    return time;
  }
}
